import { render, staticRenderFns } from "./UploadLogotipo.vue?vue&type=template&id=da0c38be&scoped=true"
import script from "./UploadLogotipo.vue?vue&type=script&lang=js"
export * from "./UploadLogotipo.vue?vue&type=script&lang=js"
import style0 from "./UploadLogotipo.vue?vue&type=style&index=0&id=da0c38be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0c38be",
  null
  
)

export default component.exports